const land_page = () => {
    return (
        <>
            <h1>Nerona</h1>
        </>
    )
}
export default land_page;